<template>
  <b-modal
    data-testid="modal-room"
    hide-footer
    controls
    :id="id"
    size="lg"
    modal-class="roomModal"
    @close="onClose"
  >
    <button
      data-testid="button-close-modal"
      type="button"
      class="close close-room"
      slot="modal-header-close"
      aria-label="Close"
    >
      <span></span>
      <span></span>
    </button>

    <div class="roomModalRooms modal-body modal-body--room">
      <div class="container-fluid px-0">
        <div class="row no-gutters justify-content-left text-left">
          <div class="col-lg-7">
            <div :id="`my-viewer-${room.id}`" class="roomModalRooms__viewer-gallery"></div>
            <div class="gallery">
              <button class="btn gallery__prev">
                <i class="rhg-font-icon--smallarrow-left"></i>
              </button>
              <span class="gallery__page"></span>
              <button class="btn gallery__next">
                <i class="rhg-font-icon--smallarrow-right"></i>
              </button>
            </div>
          </div>

          <div class="col-lg-5">
            <div class="roomModalRooms__info">
              <section class="intro">
                <LargeText data-testid="modal-room-title" class="intro__title">{{
                  room.name
                }}</LargeText>
                <RoomFeaturesBadge :room="room" />
                <HtmlBlock class="intro__description" :html="room.description"></HtmlBlock>
              </section>

              <section class="servicesList">
                <h3 class="servicesList__title">{{ translate('rdRoomFeatures') }}</h3>
                <ul class="servicesList__list">
                  <li
                    v-for="(service, i) in room.services"
                    :key="`roomServices-${i}`"
                    class="servicesList_items"
                  >
                    <ServiceComponent class="pb-2 servicesList_atom" :service="service" />
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Room from '../../domain/Room'
import RoomFeaturesBadge from './RoomFeaturesBadge.vue'
import ServiceComponent from './ServiceComponent'
import LargeText from '../shared/LargeText'
import HtmlBlock from '../shared/HtmlBlock'
const { mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'RoomModalRooms',
  components: {
    RoomFeaturesBadge,
    ServiceComponent,
    LargeText,
    HtmlBlock
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    room: {
      type: Room
    },
    hotelCode: String
  },
  computed: {
    ...mapGetters(['hotel']),
    fullScreenImg: () =>
      (window.appGlobalProps.assetsUrl || 'https://statics-dev.radissonhotels.com/main') +
      '/img/fullscreen.png',
    galleryImages: function () {
      return this.room.galleryImages.filter(i => !i.videoUrl)
    }
  },
  methods: {
    openFullScreen() {
      document.fullscreenElement
        ? document.exitFullscreen()
        : this.$refs.roomModalCrousel.$refs.inner.requestFullscreen()
    },
    onClose() {
      global.dispatchEvent(new Event('destoy-embedded-gallery-viewer'))
    }
  }
}
</script>

<style lang="scss">
// @import '~bootstrap/scss/functions';
// @import '~bootstrap/scss/variables';
// @import '~bootstrap/scss/mixins';
// @import '~bootstrap/scss/root';
// @import '~bootstrap/scss/carousel';
.modal-lg {
  max-width: 1000px;
}

.roomModalRooms {
  margin-top: 70px;
  @media (min-width: 992px) {
    border-radius: 8px;
    min-height: 546px;
    padding: 34px 5px 22px 34px;
  }

  &__info {
    padding: 24px 20px;
    border-top: 1px color('alto') solid;
    @media (min-width: 992px) {
      border-top: none;
      max-height: 460px;
      padding: 0 36px;
      overflow-y: auto;
      overflow-x: hidden;
      scrollbar-width: thin;

      &::-webkit-scrollbar {
        width: 5px;
        border-radius: 100vw;
        cursor: pointer !important;
      }
      &::-webkit-scrollbar-track {
        border-radius: 100vw;
        background: none;
        margin-block: 5px;
        cursor: pointer !important;
      }
      &::-webkit-scrollbar-thumb {
        border: 1px color('alto') solid;
        background-color: color('alto');
        border-radius: 100vw;
        margin: 0 5px;
        cursor: pointer !important;
      }
    }
  }

  &__viewer-gallery {
    display: flex;
    width: 100%;
    min-height: 230px;
    @media (min-width: 992px) {
      width: 100%;
      height: 374px;
      border-radius: 8px;
      overflow: hidden;
      background-color: #29343d;
    }
  }

  .gallery {
    width: 100%;
    text-align: right;
    display: flex;
    margin-top: 24px;
    justify-content: space-between;
    padding: 0 20px 20px;

    @media (min-width: 992px) {
      justify-content: end;
      margin-top: 36px;
      padding: 0;
    }

    &__prev,
    &__next {
      display: flex;
      justify-content: center;
      align-items: center;
      color: inherit;
      background: inherit;
      width: 36px;
      height: 36px;
      font-size: 36px;
      border: solid 2px #000;
      border-radius: 50px;
      .rhg-font-icon--smallarrow-right {
        margin-right: 0;
      }
      .rhg-font-icon--smallarrow-left {
        margin-right: 2px;
      }
    }

    &__page {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      @media (min-width: 992px) {
        justify-content: center;
        width: 60px;
      }
    }
  }

  .intro {
    &__title {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 10px;
      @media (min-width: 992px) {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 6px;
      }
    }

    &__description {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 10px;
      @media (min-width: 992px) {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }

  .servicesList {
    &__title {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 0;
      padding-top: 10px;
    }

    &__list {
      display: grid;
      grid-template-columns: auto auto auto;
      column-gap: 20px;
      margin-left: 0;
      margin-right: 0;
    }

    &_items {
      display: flex;
      flex-direction: column;
      margin: 20px 0 0;
      align-items: center;
      .service {
        max-width: 90px;
        &__name {
          font-size: 12px;
          line-height: 16px;
          @media (min-width: 992px) {
            font-size: 9px;
            line-height: 11px;
          }
        }
      }
    }

    span {
      font-size: 12px;
      line-height: 16px;
      @media (min-width: 992px) {
        font-size: 10px;
      }
    }
  }
}

.service__name {
  font-size: 12px;
  line-height: 16px;
  @media (min-width: 992px) {
    font-size: 10px;
    line-height: 10px;
  }
}

.roomModal {
  .close {
    top: 26px;
    right: 26px;
    z-index: 2;

    @media (min-width: 992px) {
      top: 84px;
      right: 36px;
      z-index: 1;
    }

    &.close-room {
      top: 0;
      right: 0;
    }

    span {
      background: #000;
      height: 3px;
      border-radius: 3px;
      width: 24px;
      + span {
        top: -3px;
      }
    }
  }

  .modal-body--room {
    margin-top: 0px;
    border-radius: 0;
    @media (min-width: 992px) {
      border-radius: 8px;
      min-height: 520px;
      padding: 34px 5px 22px 34px;
    }
  }
}

.roomModal {
  &.modal.fade.show {
    @media (max-width: 991px) {
      padding-left: 0 !important;
      background: #fff;
    }
  }
  @media (max-width: 991px) {
    .modal-dialog {
      margin: 0px;
      max-width: 100%;
      width: 100%;
      height: 100vh;
    }

    &.modal.fade.show {
      padding-left: 0 !important;
    }

    &.modal {
      .modal-header {
        background-color: #fff;
        min-height: 70px;
      }
      .modal-body {
        max-height: initial;
      }
    }
  }
}

html[dir='rtl'] {
  .roomModal {
    .close {
      left: 26px;
      right: auto;

      @media (min-width: 992px) {
        left: 30px;
        right: auto;
      }
    }
  }

  .roomModalRooms .gallery {
    flex-direction: row-reverse;
  }
}
</style>
